import { Box, ButtonBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";

import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { CatogoryDropdown } from "./category/CatogoryDropdown";
import cx from 'classnames';
import { chartTypes, reportFilterComponentTypes } from "../chartFilterEnums";
import { RhCategoryBoolean } from "./category/RhCategoryBoolean";
import { CategorySearchQueryDropdown } from "./category/CategorySearchQueryDropdown";
import { CategoryCountryDropdown } from "./category/CategoryCountryDropdown";

export const ReportDetailsPageDetails = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    return (

        <PopoverModal
            {...props}
            triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    paddingBottom: isStandAlone ? 4 : 0.5,
                    borderRadius:"16px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderTopLeftRadius:"12px",
                        borderTopRightRadius:"12px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                <Box
                    sx={{
                        p:3,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        width:500,
                        borderRadius:4,
                        "@media screen and (max-width: 768px)" : {
                            width:"unset",
                        }
                    }}
                >
                    <RhReportCategory
                        currentReport={props.currentReport}
                        chartOption={props.chartOption}
                        setCurrentReport={props.setCurrentReport}
                        filtersRegistry={props.filtersRegistry}
                    />
                </Box>
            </Box>
        </PopoverModal>
    )
}

export const RhReportCategory = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        (props.currentReport?.displayType === chartTypes.BAR && props.currentReport.category.use) && (
            props.chartOption?.filters.map((key, idx) => (
                <ButtonBase
                    className={cx(undefined, {
                        'selected': props.currentReport.category.key === key,
                    })}
                    onClick={() => {
                        if(props.currentReport.category.key !== key) {
                            props.setCurrentReport(prev => ({
                                ...prev,
                                category: {
                                    ...prev.category,
                                    key:key,
                                    values: [], 
                                },
                            }));
                        }
                    }}
                    sx={{
                        width:1,
                        mt:1,
                        borderRadius:5,
                        px:2,
                        pr:0.5,
                        height:40,
                        display:"flex",
                        alignItems:'center',
                        justifyContent:"space-between",
                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        "&.selected" : {
                            background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                            borderColor:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                        }
                    }}
                >
                    <Text
                        semibold={props.currentReport.category?.key === key}
                        variant={props.currentReport.category?.key === key ? theme.palette.mode === "dark" ? "blue" : "primary" : null}
                    >
                        {t(props.filtersRegistry.filters[key].name)}
                    </Text>
                    {(() => {
                        if (props.currentReport.category.key !== key) return null;

                        const filterConfig = typeof props.filtersRegistry.filters[key] === "function"
                            ? props.filtersRegistry.filters[key]()
                            : props.filtersRegistry.filters[key];
                        return filterConfig?.componentType === reportFilterComponentTypes.DROPDOWN ? (
                            <CatogoryDropdown
                                fKey={key}
                                category={props.currentReport.category}
                                setCurrentReport={props.setCurrentReport}
                            />
                        )  : filterConfig?.componentType === reportFilterComponentTypes.COUNTRIES ? (
                            <CategoryCountryDropdown
                                fKey={key}
                                category={props.currentReport.category}
                                setCurrentReport={props.setCurrentReport}
                            />
                        ) : filterConfig?.componentType === reportFilterComponentTypes.SEARCHQUERYDROPDOWN ? (
                            <CategorySearchQueryDropdown
                                fKey={key}
                                category={props.currentReport.category}
                                setCurrentReport={props.setCurrentReport}
                            />
                        ) : filterConfig?.componentType === reportFilterComponentTypes.BOOLEAN ?
                            <RhCategoryBoolean
                                fKey={key}
                                category={props.currentReport.category}
                                setCurrentReport={props.setCurrentReport}
                            />
                        :
                        null
                        ;
                    })()}

                </ButtonBase>
            ))
        )     
    )
}